
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/karaoke-rental",
      function () {
        return require("private-next-pages/karaoke-rental.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/karaoke-rental"])
      });
    }
  